module.exports = __webpack_public_path__ + "img/6.dde955d9.jpg";